import { styled } from '../jss-style';
import checkboxStyle from './checkbox';

const useCheckboxStyle = styled(checkboxStyle, 'checkbox');
export { checkboxStyle, useCheckboxStyle };
export default useCheckboxStyle;
